import React, {Component} from 'react'
import * as config from '../Configuration/Config.js'
import * as pbi from 'powerbi-client';
import * as models from 'powerbi-models';
import {isMobile} from 'react-device-detect';
import { Redirect } from 'react-router-dom';
import UserProfile from '../Configuration/UserProfile'
// import qs from 'query-string';

class VisualizationEdit extends Component {
    componentDidMount() {
        const rid = this.props.match.params.rid;
        const gid = this.props.match.params.gid;

        this.profile = new UserProfile();        
        var varCustomerId = this.profile.CustomerId();
        console.log('EDIT varCustomerId: ' + varCustomerId);
        
        //customerinfo
        var that = this;        
        const uricst = config.getUriPath('customers/' + varCustomerId)
        var varCustomerCustomWorkspace = ''; 
        fetch(uricst, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
            if (response.status >= 400) {
              throw new Error("Bad response from server");
            }
            return response.json();
          })
          .then(function(data) {           
            console.log(data);
            console.log('data.customer_custom_workspace_id ' + data.customer_custom_workspace_id);
            if(data.customer_custom_workspace_id == null)
            {
              console.log('redirect');
              window.location.replace('/visualizations/view/' + rid + '/' + gid);
            }
            if (data.customer_custom_workspace_id.toLowerCase() !== gid.toLowerCase())
            {
              console.log('redirect');
              window.location.replace('/visualizations/view/' + rid + '/' + gid);
            }
        });

        

        const uri = config.getUriPath('visualizations/embedToken?id=' + rid + '&group_id=' + gid)

        const mobileLayout = models.LayoutType.MobilePortrait;
        const desktopLayout = models.LayoutType.Custom;
        var thisLayout = desktopLayout;
        if (isMobile) {
            thisLayout = mobileLayout;
        }
        var v_viewMode = models.ViewMode.Edit;
        var v_Permissions = models.Permissions.All;
        
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
            if (response.status >= 400) {
              throw new Error("Bad response from server");
            }

            if (response.status >= 204) {
                return null;
            }

            return response.json();
          })
          .then(function(data) {
            if (data == null) {
                return;
            }

            const embedUrl = "https://app.powerbi.com/reportEmbed?reportId=" + rid + "&groupId=" + gid;

            var pbiconfig = {
                type: 'report',
                tokenType: 1,
                accessToken: data.token,
                embedUrl: embedUrl,
                id: rid,
                permissions: v_Permissions,
                viewMode: v_viewMode,
                settings: {
                  filterPaneEnabled: true,
                  navContentPaneEnabled: true,
                  background: 1,                  
                  layoutType: thisLayout,
                  panes: {
                    pageNavigation: {visible: true, position: 1}
                    }
                  }
                };

                let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
                var reportContainer = document.getElementById('rptContainer');
                
               var report = powerbi.embed(reportContainer, pbiconfig); 
               report.on("saved", function (event) {
                 console.log(event.detail);
                 if (event.detail.saveAs) {
                    console.log('redirect to new report');
                    var varCurrentRID = event.detail.originalReportObjectId;
                    var varNewRID  = event.detail.reportObjectId;
                    var currentURL = window.location.href;
                    var newURL = currentURL.replace(varCurrentRID,varNewRID);
                    console.log(newURL);
                    //return <Redirect to={newURL} />
                    window.location.replace(newURL);
                 }
               });
               report.on("error", function (event) {
                console.log(event.detail);                
               });   
          });
    }

    render() {
        return <div>
                    <div className="center-div">
                        <div className="rptContainer" id="rptContainer">&nbsp;</div>
                    </div>
                </div>
    }
}

export default VisualizationEdit


// WEBPACK FOOTER //
// ./src/Components/Visualizations/VisualizationEdit.js